export const COMMERCIAL_UNIT_CODE_EXCLUDE_PATTERN = "[uUvV][0-9][A-Za-z0-9]*";

export function packageGtins(packages: unknown): string[] {
  if (!Array.isArray(packages)) return [];
  const values = packages.flatMap((item) => {
    if (!item || typeof item !== "object") return [];
    const gtin = (item as Record<string, unknown>).PackageGtin;
    return typeof gtin === "string" && gtin.trim() ? [gtin.trim()] : [];
  });
  return [...new Set(values)];
}

export function isInternalCommercialUnitCode(value: unknown): boolean {
  return typeof value === "string" && /^[uv]\d+[a-z0-9]*$/i.test(value.trim());
}
